// @flow
import * as React from 'react'
import { StyledCard, ReloadDataContainer } from './style'
import { Button } from 'antd'

type Props = {
  loading: boolean,
  empty: boolean,
  title: string,
  resetData: void => void,
  children: React.Node
}

class ComponentContainer extends React.Component<Props> {

  render() {

    const { 
      loading, 
      empty, 
      title, 
      resetData, 
      children
    } = this.props

    return (
      <StyledCard 
        loading={loading}
        bordered={false} 
        title={title}>

        { empty ?
          (
            // display loading
            <ReloadDataContainer>
              <Button icon='reload' onClick={resetData}>Reload Content</Button>
            </ReloadDataContainer>
          ) :
          (
            // display component
            <section>{children}</section>
          )
        }
      </StyledCard>
    )
  }
}

export default ComponentContainer



// WEBPACK FOOTER //
// ./src/components/container-component/index.js